import React from 'react';
import { ReactComponent as FigTrash01Component } from './FigTrash01.svg';

const FigTrash01 = (props) => <FigTrash01Component {...props} />;

export default FigTrash01;
